import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  connectSocket,
  disconnectSocket,
  getSocket,
} from "./socket/websocketService";

const initialState = {
  isConnected: false,
  onlineusers: [],
  orgeditusers: {},

  connect_assistant: {},
  reconnectAttempts: 0,
  maxReconnectAttempts: 5,
};
let socket = getSocket();

export const connectWebSocket = createAsyncThunk(
  "websocket/connect",
  async (_, { getState, dispatch }) => {
    if (socket && socket?.readyState === 1) {
      console.warn("WebSocket is already connected, skipping reconnection.");
      return;
    }
    // const token1 = getState()?.admin?.admin?.jwtAdminToken;
    const token = localStorage.getItem("lsh-token");

    const socketUrl = import.meta.env.VITE_Backend_URL;
    
    const deviceId=getState()?.admin?.deviceId
    const wsUrl = `${socketUrl}`;

    connectSocket({url:wsUrl,token,deviceId}, dispatch);
  }
);

export const disconnectWebSocket = createAsyncThunk(
  "websocket/disconnect",
  async (_, { dispatch }) => {
    disconnectSocket(dispatch);
  }
);

const websocketSlice = createSlice({
  name: "websocket",
  initialState,
  reducers: {
    connectionEstablished: (state, action) => {
      state.isConnected = true;
      state.error = null;
    },
    connectionLost: (state, action) => {
      state.isConnected = false;
      state.error = action.payload?.reason || "Disconnected";
    },
    setOnlineUsers: (state, action) => {
      state.onlineusers = action.payload;

    },
    setOrgUsers: (state, action) => {
      state.orgeditusers = action.payload;
      console.log("recieve message", action.payload);
    },

    errorOccurred: (state, action) => {
      state.error = action.payload;
    },

  },
});

export const {
  connectionEstablished,
  connectionLost,
  errorOccurred,
  // attemptReconnect,
  // resetReconnectAttempts,
  sendAlert,
  recieveAlert,
  setOrgUsers
} = websocketSlice.actions;
export const websocketSelector = (state) => state.websocket;
export const orgwarndata = (state) => state.websocket.orgeditusers

export default websocketSlice.reducer;

